export const OPTION_FIELD_KEYS = ["turno", "cargo"] as const;

export type OptionFieldKey = (typeof OPTION_FIELD_KEYS)[number];

const OPTION_FIELD_LABELS: Record<OptionFieldKey, string> = {
  turno: "Turno",
  cargo: "Cargo",
};

export const getEnabledOptionFieldsWithoutSelection = (
  selection: Record<OptionFieldKey, readonly unknown[]>,
  isEnabled: (key: OptionFieldKey) => boolean,
): OptionFieldKey[] =>
  OPTION_FIELD_KEYS.filter((key) => isEnabled(key) && selection[key].length === 0);

export const formatMissingOptionFieldsError = (fields: readonly OptionFieldKey[]): string => {
  const labels = fields.map((field) => OPTION_FIELD_LABELS[field]);
  const fieldList = labels.length > 1
    ? `${labels.slice(0, -1).join(", ")} y ${labels[labels.length - 1]}`
    : labels[0];

  return `Debes seleccionar al menos una opción para ${fieldList} antes de guardar.`;
};
